import DroppableMBoxCard from './DroppableWrapper';
import MBoxCard from './MBoxCard';

export { DroppableMBoxCard };
export default MBoxCard;
